import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectionListChange } from '@angular/material/list';
import { deepCopyFunction } from 'src/app/data/utils/object.utils';
import { HistoryFilterCategory } from './model/history-filter-category';

@Component({
  templateUrl: './dialog-history-filter.component.html',
  styleUrls: ['./dialog-history-filter.component.scss'],
})
export class DialogHistoryFilterComponent implements OnInit {
  dirty: boolean = false;
  category!: HistoryFilterCategory[];

  constructor(
    public dialogRef: MatDialogRef<DialogHistoryFilterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: HistoryFilterCategory[]
  ) {}

  ngOnInit(): void {
    this.category = deepCopyFunction(this.data);
  }

  handleSelect(event: MatSelectionListChange, category: string) {
    this.dirty = true;
    const filtered = this.category.filter((elem) => elem.name === category);
    filtered[0].options.forEach(
      (opt) =>
        (opt.selected =
          opt.value === event.source.selectedOptions.selected[0].value)
    );
  }

  clear() {
    this.category = deepCopyFunction(this.data);
    this.dirty = false;
  }

  apply() {
    this.dialogRef.close(this.category);
  }
}
